module.exports = __webpack_public_path__ + "static/media/zero.d82cbfb2.jpg";